// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isSubscriptionGroup = objectOf({
  id: string,
  name: maybe(string, true),
  app_group_id: maybe(string, true),
  app_group_name: maybe(string, true),
});

export const isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroupsResult = objectOf({
  subscription_groups: arrayOf(isSubscriptionGroup),
});
